module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/CPU1-54986c0e76cbe8e02c9acf684632cc46.svg";